import React from 'react';
import { partners } from '../data/mock';
import { Card, CardContent } from '../components/ui/card';
import { Building2, Users, Handshake, TrendingUp } from 'lucide-react';

export const Partners = () => {
  const partnerBenefits = [
    {
      icon: Building2,
      title: 'Expand Your Reach',
      description: 'Connect with thousands of daily commuters actively seeking travel options'
    },
    {
      icon: Users,
      title: 'Seamless Integration',
      description: 'Easy API integration with comprehensive documentation and support'
    },
    {
      icon: Handshake,
      title: 'Trusted Partnership',
      description: 'Join India\'s leading transport providers in our ecosystem'
    },
    {
      icon: TrendingUp,
      title: 'Grow Together',
      description: 'Benefit from our growing user base and marketing efforts'
    }
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#1B4F72] to-[#138808] text-white py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl font-bold mb-6">Our Partners</h1>
          <p className="text-xl text-gray-100 max-w-3xl mx-auto leading-relaxed">
            Collaborating with India's leading transport providers to deliver seamless mobility
          </p>
        </div>
      </section>

      {/* Current Partners */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[#1B4F72] mb-4">Trusted Integrations</h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              We've partnered with the best to bring you comprehensive travel options
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {partners.map((partner) => (
              <Card key={partner.id} className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
                <CardContent className="p-8 text-center">
                  <div className="text-5xl mb-4">
                    {partner.category === 'Train' && '🚂'}
                    {partner.category === 'Bus' && '🚌'}
                    {partner.category === 'Metro' && '🚇'}
                    {partner.category === 'Cab' && '🚕'}
                    {partner.category === 'Bike' && '🏍️'}
                    {partner.category === 'Flight' && '✈️'}
                  </div>
                  <h3 className="text-xl font-bold text-[#1B4F72] mb-2">{partner.name}</h3>
                  <span className="inline-block px-3 py-1 bg-[#FF9933]/10 text-[#FF9933] rounded-full text-sm font-medium">
                    {partner.category}
                  </span>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Partner Benefits */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[#1B4F72] mb-4">Why Partner With Us?</h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Join our ecosystem and benefit from integrated mobility solutions
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {partnerBenefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return (
                <Card key={index} className="border-0 shadow-lg hover:shadow-xl transition-shadow duration-300">
                  <CardContent className="p-8 text-center">
                    <div className="w-16 h-16 bg-gradient-to-br from-[#FF9933] to-[#E68A2E] rounded-full flex items-center justify-center mx-auto mb-6">
                      <Icon className="text-white" size={28} />
                    </div>
                    <h3 className="text-xl font-bold text-[#1B4F72] mb-3">{benefit.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Become a Partner CTA */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-[#1B4F72] to-[#138808] text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6">Become a Partner</h2>
          <p className="text-xl text-gray-100 mb-8 leading-relaxed">
            Join India's fastest-growing integrated mobility platform and expand your reach
          </p>
          <button className="bg-[#FF9933] hover:bg-[#E68A2E] text-white font-semibold px-10 py-4 rounded-lg shadow-xl transition-all duration-300 hover:scale-105 text-lg">
            Get in Touch
          </button>
        </div>
      </section>
    </div>
  );
};
